import { createSvgIcon } from "@mui/material";

export const AudioIcon = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M10.375 3.25006C10.7134 3.25006 10.9998 3.59959 11 4.01276V19.9874C10.9998 20.4005 10.7134 20.7501 10.375 20.7501C10.0366 20.7501 9.7502 20.4005 9.75 19.9874V4.01276C9.75018 3.59959 10.0366 3.25006 10.375 3.25006Z"
      fill="currentColor"
    />
    <path
      d="M16.875 5.28522C17.2135 5.28522 17.5 5.63461 17.5 6.04791V17.9522C17.4999 18.3655 17.2135 18.7149 16.875 18.7149C16.5365 18.7149 16.2501 18.3655 16.25 17.9522V6.04791C16.25 5.63461 16.5365 5.28522 16.875 5.28522Z"
      fill="currentColor"
    />
    <path
      d="M7.125 6.3028C7.46354 6.3028 7.75 6.65216 7.75 7.06549V16.9346C7.74999 17.348 7.46354 17.6973 7.125 17.6973C6.78646 17.6973 6.50001 17.348 6.5 16.9346V7.06549C6.5 6.65216 6.78646 6.3028 7.125 6.3028Z"
      fill="currentColor"
    />
    <path
      d="M13.625 7.3194C13.9635 7.3194 14.25 7.66973 14.25 8.08307V15.9171C14.25 16.3304 13.9635 16.6807 13.625 16.6807C13.2865 16.6807 13 16.3304 13 15.9171V8.08307C13 7.66973 13.2865 7.3194 13.625 7.3194Z"
      fill="currentColor"
    />
    <path
      d="M3.875 9.35455C4.21354 9.35455 4.5 9.70489 4.5 10.1182V13.8819C4.5 14.2952 4.21354 14.6456 3.875 14.6456C3.53646 14.6456 3.25 14.2952 3.25 13.8819V10.1182C3.25 9.70489 3.53646 9.35455 3.875 9.35455Z"
      fill="currentColor"
    />
    <path
      d="M20.125 9.35455C20.4635 9.35455 20.75 9.70489 20.75 10.1182V13.8819C20.75 14.2952 20.4635 14.6456 20.125 14.6456C19.7865 14.6456 19.5 14.2952 19.5 13.8819V10.1182C19.5 9.70489 19.7865 9.35455 20.125 9.35455Z"
      fill="currentColor"
    />
  </svg>,
  "AudioIcon",
);
